module.exports = __webpack_public_path__ + "img/umi.8754eddf.svg";